const school_mng_routes = [
    [
        // 校管理主页
        {
            path: "/schoolmnghome",
            name: "SchoolMngHome",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '管理主页'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngHome" */
                    "../../views/personal/schoolMng/SchoolMngHome.vue"
                ),
        },
        // 校管学校信息管理
        {
            path: "/schoolmnginfo",
            name: "SchoolMngInfo",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '学校信息管理'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngInfo" */
                    "../../views/personal/schoolMng/SchoolMngInfo.vue"
                ),
        },
        // 校管学校信息管理
        {
            path: "/schoolmngteam",
            name: "SchoolMngTeam",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '人员管理'
                },
                {
                    path: '/',
                    name: '校培训团队管理'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngTeam" */
                    "../../views/personal/schoolMng/SchoolMngTeam.vue"
                ),
        },
        // 校管添加人员
        {
            path: "/schoolmngaddstaff",
            name: "SchoolMngTeam",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '人员管理'
                },
                {
                    path: '/',
                    name: '校培训团队管理'
                },
                {
                    path: '/',
                    name: '添加人员'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngAddStaff" */
                    "../../views/personal/schoolMng/SchoolMngAddStaff.vue"
                ),
        },
        // 校管批量导入
        {
            path: "/schoolmngaddmorestaff",
            name: "SchoolMngTeam",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '人员管理'
                },
                {
                    path: '/',
                    name: '校培训团队管理'
                },
                {
                    path: '/',
                    name: '批量导入'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngAddMoreStaff" */
                    "../../views/personal/schoolMng/SchoolMngAddMoreStaff.vue"
                ),
        },
        // 校管教师管理
        {
            path: "/schoolmngtearcher",
            name: "SchoolMngTearcher",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '人员管理'
                },
                {
                    path: '/',
                    name: '校培训团队管理'
                },
                {
                    path: '/',
                    name: '教师管理'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngTearcher" */
                    "../../views/personal/schoolMng/SchoolMngTearcher.vue"
                ),
        },
        // 校管学校信息化发展计划
        {
            path: "/schoolmngdevelopplan",
            name: "SchoolMngDevelopPlan",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '学校信息化发展计划'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngDevelopPlan" */
                    "../../views/personal/schoolMng/SchoolMngDevelopPlan.vue"
                ),
        },
        // 校管校本研修与考核方案
        {
            path: "/schoolmngstudyplan",
            name: "SchoolMngStudyPlan",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '校本研修与考核方案'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngStudyPlan" */
                    "../../views/personal/schoolMng/SchoolMngDevelopPlan.vue"
                ),
        },
        // 校管教师微能力申报
        {
            path: "/schoolmngtearcherdclare",
            name: "SchoolMngTearcherDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师微能力申报'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngStudyPlan" */
                    "../../views/personal/areaTrain/areaTrainAbilityDclareDetail.vue"
                ),
        },
        // 个人测评报告测评报告
        {
            path: "/personagetestnoticeschool",
            name: "SchoolMngTearcherDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: 'xxx教师微能力测评报告'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "PersonageTestNotice" */
                    "../../views/personal/PersonageTestNotice.vue"
                ),
        },
        // 综合测评报告
        {
            path: "/synthesizetestnotice",
            name: "SchoolMngTearcherDclare",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师微能力测评'
                },
                {
                    path: '/',
                    name: 'xxx测评'
                },
                {
                    path: '/',
                    name: '教师微能力测评报告(综合)'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SynthesizeTestNotice" */
                    "../../views/personal/SynthesizeTestNotice.vue"
                ),
        },
        // 教师信息技术应用能力等次
        {
            path: "/schoolmngtearchergrade",
            name: "SchoolMngTearcherGrade",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师信息技术应用能力等次'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngTearcherGrade" */
                    "../../views/personal/schoolMng/SchoolMngTearcherGrade.vue"
                ),
        },

        // 校本实践考核
        {
            path: "/schoolMngTearcherAssessment",
            name: "SchoolMngTearcherAssessment",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '校本实践考核'
                }
                ]
            },
            component: () =>
                import(
                    "../../views/personal/schoolMng/SchoolMngTearcherAssessment.vue"
                ),
        },

        // 校本实践考核
        {
            path: "/schoolMngAssessDetails",
            name: "SchoolMngAssessDetails",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '校本实践考核'
                }
                ]
            },
            component: () =>
                import(
                    "../../views/personal/schoolMng/SchoolMngAssessDetails.vue"
                ),
        },
        // 教师证书详情
        {
            path: "/abilitycertificatedetail",
            name: "SchoolMngTearcherGrade",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师信息技术应用能力等次'
                },
                {
                    path: '/',
                    name: '证书详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityCertificateDetail" */
                    "../../views/personal/tearch/ability/AbilityCertificateDetail.vue"
                ),
        },
        // 查看微能力教师成果
        {
            path: "/schoolmnglookabilitycg",
            name: "SchoolMngTearcherGrade",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '教师信息技术应用能力等次'
                },
                {
                    path: '/',
                    name: '成果详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngLookAbilityCg" */
                    "../../views/personal/schoolMng/SchoolMngLookAbilityCg.vue"
                ),
        },
        // 成果管理
        {
            path: "/schoolmngachievement",
            name: "SchoolMngAchievement",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '成果管理'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngAchievement" */
                    "../../views/personal/schoolMng/SchoolMngAchievement.vue"
                ),
        },
        // 查看项目类别成果
        {
            path: "/schoolmngprojectsortcg",
            name: "SchoolMngAchievement",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '成果管理'
                },
                {
                    path: '/',
                    name: '双师项目类别'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngProjectSortCg" */
                    "../../views/personal/schoolMng/SchoolMngProjectSortCg.vue"
                ),
        },
        // 整校推进评估
        {
            path: "/schoolmngwholeevalute",
            name: "SchoolMngWholeEvalute",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评估'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngWholeEvalute" */
                    "../../views/personal/schoolMng/SchoolMngWholeEvalute.vue"
                ),
        },
        // 教师微能力提升清单
        {
            path: "/schoolmngpromotelist",
            name: "SchoolMngWholeEvalute",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评估'
                },
                {
                    path: '/',
                    name: '教师微能力提升清单'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngPromoteList" */
                    "../../views/personal/schoolMng/SchoolMngPromoteList.vue"
                ),
        },
        // 信息技术与课堂教学融合调研报告
        {
            path: "/schoolmngjsteachnotice",
            name: "SchoolMngWholeEvalute",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '整校推进评估'
                },
                {
                    path: '/',
                    name: '信息技术与课堂教学融合调研报告'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "SchoolMngJsTeachNotice" */
                    "../../views/personal/schoolMng/SchoolMngJsTeachNotice.vue"
                ),
        },
        // 微能力测评服务
        {
            path: "/abilityevaluation",
            name: "AbilityEvaluation",
            meta: {
                showName: 1,
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评服务'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityEvaluation" */
                    "../../views/personal/schoolMng/SchoolMngTearcherTest.vue"
                ),
        },
        // 微能力测评服务详情
        {
            path: "/schoolMngTearcherDetails",
            name: "SchoolMngTearcherDetails",
            meta: {
                showName: 1,
                breadCrumd: [{
                    path: '/',
                    name: '培训管理'
                },
                {
                    path: '/',
                    name: '微能力测评服务'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "AbilityEvaluation" */
                    "../../views/personal/schoolMng/SchoolMngTearcherDetails.vue"
                ),
        },
    ],
    [
        // 校管待评审详情
        {
            path: "/nocommentdetail",
            name: "SchoolMngAchievement",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '成果评审'
                },
                {
                    path: '/',
                    name: '成果详情'
                }
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NoCommentDetail" */
                    "../../views/personal/tearch/ability/NoCommentDetail.vue"
                ),
        },
        // 校管购买页面
        {
            path: "/nowtopay",
            name: "AbilityEvaluation",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '微能力测评服务'
                },
                {
                    path: '/',
                    name: 'xxxx测评'
                },
                {
                    path: '/',
                    name: '购买'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NoCommentDetail" */
                    "../../views/personal/tearch/NowToPay.vue"
                ),
        },
        // 微能力教师成果认定详情  
        {
            path: '/abilityconfirmdetail',
            name: 'AbilityConfirmDetail',
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                },
                ]
            },
            component: () => import( /* webpackChunkName: "AbilityConfirmDetail" */ '../../views/personal/tearch/ability/AbilityConfirmDetail.vue'),
        },
        // 非微能力教师成果详情
        {
            path: "/noabilityachievementxq",
            name: "NoAbilityAchievementRd",
            meta: {
                breadCrumd: [{
                    path: '/',
                    name: '信息技术应用能力认定'
                },
                {
                    path: '/',
                    name: '成果认定'
                },
                {
                    path: '/',
                    name: '成果详情'
                },
                ]
            },
            component: () =>
                import(
                    /* webpackChunkName: "NoAbilityAchievementRd" */
                    "../../views/personal/tearch/no_ability/NoAbilityAchievementXq.vue"
                ),
        },
    ],
];

export default school_mng_routes;